export default "__VITE_ASSET__D7e72yHY__"